import { render, staticRenderFns } from "./add_Position.vue?vue&type=template&id=8a241810&scoped=true"
import script from "./add_Position.vue?vue&type=script&lang=js"
export * from "./add_Position.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a241810",
  null
  
)

export default component.exports